@let _supportsHover = this.breakpoint2Service.supportsHover$ | async;

<sb-gallery-overlay
  class="fill-parent"
  [disableDrag]="galleryOverlayPhotoComponent?.magnifierDirective!.isZoomed()"
  [hideActions]="galleryOverlayPhotoComponent?.isDeeplyFocused ? (_supportsHover ? [] : ['top']) : []"
>
  <sb-gallery-overlay-photo gallery-overlay-action="main" [url]="message.photo.url" />

  @if (galleryOverlayPhotoComponent?.magnifierDirective!.canZoomOut()) {
    <button
      class="mr-2"
      gallery-overlay-action="top-right"
      sbButton
      [iconOnly]="true"
      [variant]="'ghost-overlay'"
      (click)="galleryOverlayPhotoComponent!.magnifierDirective.zoomOut()"
    >
      <sb-icon [name]="'big-minus-thick'" [size]="'6'" />
    </button>
  }

  @if (galleryOverlayPhotoComponent?.magnifierDirective!.canZoomIn()) {
    <button
      class="mr-2"
      gallery-overlay-action="top-right"
      sbButton
      [iconOnly]="true"
      [variant]="'ghost-overlay'"
      (click)="galleryOverlayPhotoComponent!.magnifierDirective.zoomIn()"
    >
      <sb-icon [name]="'big-add-thick'" [size]="'6'" />
    </button>
  }

  @if (countdown) {
    <sb-expire-graph gallery-overlay-action="top-center" [theme]="'message-photo'" [value]="countdown" />
  }
</sb-gallery-overlay>
